(function(){
'use strict';

/**
 * @name scFundraisingActivityDemo
 *
 * @description
 * Generates demo activity data for a fundraising page.
 */
angular.module('classy').factory('scFundraisingActivityDemo', ['scOrganizationsService', 'scCampaignsService', 'scMembersService', function (scOrganizationsService, scCampaignsService, scMembersService) {
  return function (fundraisingPageId) {
    return {
      current_page: 1,
      data: [{
        fundraising_team_id: null,
        link_id: 1,
        link_text: "Fundraiser's Name",
        id: 1,
        type: 'creation',
        member_id: 1,
        organization_id: scOrganizationsService.active.current.id,
        campaign_id: scCampaignsService.active.current.id,
        fundraising_page_id: fundraisingPageId,
        created_at: new Date().toISOString(),
        transaction_id: 0,
        organization: scOrganizationsService.active.current,
        member: scMembersService.you.current,
        member_name: 'undefined undefined',
        fundraising_team: null,
        transaction: null,
        campaign: scCampaignsService.active.current,
        comments: [],
        business: null,
        feedable_type: 'fundraising_page',
        designation: {
          id: 1,
          name: 'General Fund Project'
        },
        demo: true
      }],
      from: 1,
      last_page: 1,
      next_page_url: null,
      per_page: 20,
      prev_page_url: null,
      to: 1,
      total: 1
    };
  };
}]);
})();